module.exports = __webpack_public_path__ + "img/top1.80831839.png";